import type { FileUploadType } from "./types";

export const DEFAULT_MAX_FILE_UPLOAD_SIZE = 4 * 1024 * 1024 * 1024;

export const UPLOAD_TAB = "upload";
export const EMBED_TAB = "embed";

export const EMBED_FORM_ID = "tiptap-file-embed-form";

export const FILE_UPLOAD_ACCEPT_BY_TYPE: Record<FileUploadType, string[]> = {
  file: ["*/*"],
  video: ["video/*"],
  audio: ["audio/*", ".mp3", ".wav", ".m4a"],
  pdf: ["application/pdf"],
};
